import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import Edit from './Icons/Edit.js';
import Input from './Input.js';
import Loading from './Loading.js';
import Results from './searchInput/Results.js';
const SearchInput = (props) => {
    const [q, setQ] = useState('');
    const [activeElm, setActiveElm] = useState(-1);
    const [resultHashMap, setResultHashMap] = useState({});
    const [focused, setFocused] = useState(false);
    const results = resultHashMap[q.trim()] ?? [];
    const loading = results === 'loading';
    const open = focused &&
        (loading || results.length >= 0) &&
        (q.trim().length > 0 || props.forceOpen);
    let toId;
    useEffect(() => {
        if (props.cacheResetTrigger) {
            console.log('Resetting search cache because cacheResetTrigger property was changed');
            setResultHashMap({});
        }
    }, [props.cacheResetTrigger]);
    useEffect(() => {
        if (props.searchDelay === 0 || resultHashMap[q.trim()]) {
            if (q !== '') {
                searchAndStates();
            }
        }
        else {
            toId = setTimeout(searchAndStates, props.searchDelay ?? 300);
        }
    }, [q]);
    const onBlur = () => {
        setTimeout(() => {
            setFocused(false);
        }, 100);
    };
    const onFocus = () => {
        search({ target: { value: q } });
        if (props.forceOpen ?? false) {
            searchAndStates();
        }
    };
    const select = (e) => {
        switch (e.key) {
            case 'Enter': {
                const categories = !loading
                    ? Array.from(new Set(results.map((r) => (r.category != null ? r.category : null))))
                    : [];
                const categoryResults = !loading
                    ? categories.map((category) => results.filter((res) => res.category === category))
                    : [];
                const hasCategories = categories.length > 1;
                const categorySizes = categoryResults
                    .map((results) => results.length)
                    .reduce((acc, len, i) => acc.concat([len + (acc[i - 1] ?? 0)]), []);
                const data = !loading
                    ? hasCategories
                        ? (() => {
                            const index = categorySizes.findIndex((len) => len > activeElm);
                            return categoryResults[index][activeElm - (categorySizes[index - 1] ?? 0)].returnData;
                        })()
                        : results[activeElm]
                            ? results[activeElm].returnData
                            : null
                    : null;
                if (data != null && props.onSelect != null) {
                    setQ('');
                    setFocused(false);
                    setActiveElm(0);
                    props.onSelect(data);
                }
                break;
            }
            case 'ArrowUp': {
                e.preventDefault();
                setActiveElm(activeElm - 1 > -1 ? activeElm - 1 : results.length - 1);
                break;
            }
            case 'ArrowDown': {
                e.preventDefault();
                setActiveElm(activeElm + 1 < results.length ? activeElm + 1 : -1);
                break;
            }
        }
    };
    const search = (e) => {
        props.searchDelay !== 0 && clearTimeout(toId);
        setQ(e.target.value);
        setFocused(true);
    };
    const searchAndStates = async () => {
        if (!resultHashMap[q.trim()]) {
            await request();
        }
    };
    const request = async () => {
        const trimmedQ = q.trim();
        const { trimmedQ: qResult, ...other } = resultHashMap;
        try {
            setResultHashMap({
                ...resultHashMap,
                [trimmedQ]: 'loading',
            });
            const res = (await props.searchAll(trimmedQ)) ?? [];
            setResultHashMap({
                ...resultHashMap,
                [trimmedQ]: res,
            });
        }
        catch (e) {
            console.error(e);
            setResultHashMap(other);
        }
    };
    const resultOnMouseDown = (result, index) => {
        setQ('');
        setFocused(false);
        setActiveElm(index);
        props.onSelect(result.returnData);
    };
    const clear = () => {
        props.onClear && props.onClear();
        setFocused(false);
        setActiveElm(-1);
    };
    return (React.createElement(Wrapper, { style: props.containerStyle },
        React.createElement(StyledInput, { disabled: props.disabled, onClick: (e) => {
                e.stopPropagation();
                if (props.static != null && props.onRemoveStatic) {
                    props.onRemoveStatic();
                }
            }, placeholder: props.placeholder ?? '', autofocus: props.autofocus, onChange: search, value: props.static != '' ? (props.static ?? q) : q, onKeyDown: select, onFocus: onFocus, onBlur: onBlur, style: {
                borderBottomLeftRadius: open
                    ? '0'
                    : props.inputStyle && props.inputStyle.borderRadius,
                borderBottomRightRadius: open
                    ? '0'
                    : props.inputStyle && props.inputStyle.borderRadius,
                ...props.inputStyle,
            }, inputRef: props.inputRef, readonly: !!props.static, className: props.className, button: (props.hasClearButton ?? false)
                ? {
                    value: 'X',
                    onClick: clear,
                }
                : undefined }),
        props.loading && (React.createElement("div", { style: {
                cursor: 'pointer',
                position: 'absolute',
                right: '10px',
                top: '10px',
            } },
            React.createElement(Loading, { style: { width: '1em', height: '1em' } }))),
        !props.loading &&
            props.static &&
            props.onRemoveStatic &&
            !props.disabled && (React.createElement(Edit, { style: {
                cursor: 'pointer',
                position: 'absolute',
                right: '0',
                top: '10px',
            }, onClick: () => {
                props.onRemoveStatic && props.onRemoveStatic();
            } })),
        React.createElement(Results, { resultOnMouseDown: resultOnMouseDown, results: results, open: open ?? false, resultsStyle: props.resultsStyle, activeElm: activeElm })));
};
export default SearchInput;
const Wrapper = styled.div `
  position: relative;
`;
const StyledInput = styled(Input) `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
`;
//# sourceMappingURL=SearchInput.js.map